/* eslint-disable no-param-reassign */
import { ProductPosition } from "shared/types/ProductPosition"

import { PayloadAction } from "@reduxjs/toolkit"

import { ProductPositionUpdatesReducerState } from "./types"

function initializeProductPositionUpdatesState(
  productPositionID: string,
  state: ProductPositionUpdatesReducerState
) {
  if (!state[productPositionID]) {
    state[productPositionID] = {}
  }
}

export function saveProductPositionUpdatesHandler(
  state: ProductPositionUpdatesReducerState,
  action: PayloadAction<{
    productPositionID: string
    updates: Partial<ProductPosition>
  }>
) {
  const { productPositionID, updates } = action.payload
  initializeProductPositionUpdatesState(productPositionID, state)
  state[productPositionID] = { ...state[productPositionID], ...updates }
}

export function resetProductPositionUpdatesHandler(
  state: ProductPositionUpdatesReducerState,
  action: PayloadAction<{ productPositionID: string }>
) {
  const { productPositionID } = action.payload
  delete state[productPositionID]
}
